import { Monitor } from 'lucide-react';
import { SITE_NAME } from '@/lib/constants/branding';

export function MobileInterstitial() {
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center px-8 text-center relative overflow-hidden">
      {/* Ambient glow — matching app shell */}
      <div className="fixed inset-0 pointer-events-none z-0" aria-hidden="true">
        <div className="absolute top-[-10%] right-[-5%] w-[600px] h-[600px] rounded-full bg-[hsl(var(--accent-orange)_/_0.06)] blur-[120px]" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[500px] h-[500px] rounded-full bg-primary/[0.04] blur-[100px]" />
      </div>

      <div className="relative z-10 max-w-sm space-y-6">
        {/* Icon */}
        <div className="mx-auto w-14 h-14 rounded-xl bg-muted/50 border border-border/50 flex items-center justify-center">
          <Monitor className="w-6 h-6 text-muted-foreground" />
        </div>

        {/* Brand */}
        <div className="space-y-2">
          <h1 className="text-lg font-semibold text-foreground tracking-tight">
            {SITE_NAME} is built for desktop
          </h1>
          <p className="text-sm text-muted-foreground leading-relaxed">
            For the best experience with your proposals and intelligence tools, please switch to a desktop or laptop browser.
          </p>
        </div>

        {/* Subtle divider */}
        <div className="w-12 h-px bg-border/50 mx-auto" />

        <p className="text-xs text-muted-foreground/60">
          We're working on mobile — stay tuned.
        </p>
      </div>
    </div>
  );
}
